export default __webpack_public_path__ + "static/media/skill.a032bd7d.svg";